import api from "../api";
import type { ApiResponse, ContactInfo } from "@/types";

export const contactInfoApi = {
    get: () => api.get<ApiResponse<ContactInfo>>('contact-info'),
    create: (formData: ContactInfo) => api.post(`/admin/contact-info/store`, formData),
    update: (updatedData: ContactInfo) => api.post(`/admin/contact-info/update`, updatedData)
}